licenses-notices-1 = BestCraft is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
licenses-notices-2 = BestCraft is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
licenses-notices-3 = You should have received a copy of the GNU Affero General Public License along with BestCraft. If not, see https://www.gnu.org/licenses/.
copyright-notices = 
    Copyright 2025 Tnze. All Rights Reserved.
    Referenced FFXIV related resources: Copyright © 2010 - 2025 SQUARE ENIX CO., LTD.

level = Lv.
recipe-level = Recipe Lv.
class-job-level = Class Job Lv.
craftsmanship = Craftsmanship
control = Control
craft-point = CP
progress = Progress
quality = Quality
durability = Durability
steps = Step
condition = Condition
difficulty = Difficulty
initial-quality = Quality
conditions = Cond. Flag
progress-divider = Progress Divider
progress-modifier = Progress Modifier
quality-divider = Quality Divider
quality-modifier = Quality Modifier
difficulty-factor = Difficulty Factor
quality-factor = Quality Factor
durability-factor = Durability Factor
material-quality-factor = Material Quality Factor

meals = Meals
medicines = Medicines

name = Name
amount = Amount

specialist = Specialist

# Job names
carpenter = Carpenter
blacksmith = Blacksmith
armorer = Armorer
goldsmith = Goldsmith
leatherworker = Leatherworker
weaver = Weaver
alchemist = Alchemist
culinarian = Culinarian

# Gearset names
default = Default
common = Common
custom = Custom { $id }

# Action names
basic-synthesis = Basic Synthesis
basic-touch = Basic Touch
masters-mend = Master's Mend
hasty-touch = Hasty Touch
rapid-synthesis = Rapid Synthesis
observe = Observe
tricks-of-the-trade = Tricks of the Trade
waste-not = Waste Not
veneration = Veneration
standard-touch = Standard Touch
great-strides = Great Strides
innovation = Innovation
final-appraisal = Final Appraisal
waste-not-ii = Waste Not II
byregot-s-blessing = Byregot's Blessing
precise-touch = Precise Touch
muscle-memory = Muscle Memory
careful-synthesis = Careful Synthesis
manipulation = Manipulation
prudent-touch = Prudent Touch
reflect = Reflect
preparatory-touch = Preparatory Touch
groundwork = Groundwork
delicate-synthesis = Delicate Synthesis
intensive-synthesis = Intensive Synthesis
trained-eye = Trained Eye
advanced-touch = Advanced Touch
prudent-synthesis = Prudent Synthesis
trained-finesse = Trained Finesse
careful-observation = Careful Observation
heart-and-soul = Heart and Soul
refined-touch = Refined Touch
daring-touch = Daring Touch
immaculate-mend = Immaculate Mend
quick-innovation = Quick Innovation
trained-perfection = Trained Perfection

DurabilityNotEnough = Durability not enough
CraftPointNotEnough = Craft point not enough
CraftingAlreadyFinished = Crafting already finished
PlayerLevelTooLow = Player level too low
RequireGoodOrExcellent = Require good or excellent
NotAllowedInWastNotBuff = Not allowed in wast not buff
OnlyAllowedInFirstStep = Only allowed in first step
LevelGapMustGreaterThanTen = Level gap must greater than 10
RequireInnerQuiet1 = Require at least 1 stack of inner quiet
RequireInnerQuiet10 = Require 10 stack of inner quiet
CarefulObservationUsed3 = Careful observation can only use 3 times
HeartAndSoulUsed = Heart and soul can be only used once
FocusNeverFailsAfterObserved = Focus never fails after observed
RequireHastyTouchSuccessed = Require hasty touch successed first
QuickInnovationUsed = Quick innovation can be only used once
NotAllowedInInnovationBuff = Not allowed in innovation buff
TrainedPerfectionUsed = Trained perfection can be only used once

# Conditions
normal = Normal
good = Good
excellent = Excellent
poor = Poor
centered = Centered
sturdy = Sturdy
pliant = Pliant
malleable = Malleable
primed = Primed
goodomen = Good Omen

# Updater
update-available = Update Available: v{ $version }
update-now = Update Now
update-not-now = Not Now
update-installing = Updating in progress, please wait patiently.
update-ask-relaunch = Update installed, relaunch?

update-pending = Updating in progress
update-error = Update failed: { $error }
update-done = Update done
update-uptodate = Up-to-date

update-started = Download update started
update-progress = Download update in progress: { $progress }
update-done = Download update finished

# Rust Errors
player-level-lower-than-recipe-requirement = Player level is lower than the recipe's requirement.
unknown-recipe-level = Unknown recipe level
solver-already-exist = Solver is already exist
solver-is-creating = Solver is already creating
solver-doesn-t-exist = Solver doesn't exist
solver-isn-t-prepared = Solver isn't prepared

# Titles
attributes = Crafter Attributes
select-recipe = Select Recipe
custom-recipe = Custom Recipe
bill-of-material = Bill of Material
settings = Settings
title = { $recipe } (Simulator Mode)

# Solvers
dp-solver = DP
raphael-solver = Raphael
bfs-solver = BFS
tnzever-rika-solver = BFS ~Tnze Impv.~
dfs-solver = DFS
